import L from 'leaflet';
import Config from '@/config.js';
import MiniMap from 'leaflet-minimap';

export default class MiniMapa {

	constructor (mapa) {

		this._mapa = mapa;
		this._configure();
	}

	_configure () {

		let omsMini = new L.TileLayer(Config.miniMap.url,
			{
				minZoom: Config.miniMap.minZoom,
				maxZoom: Config.miniMap.maxZoom
			});
		
		let miniMapOptions = {
			width: Config.miniMap.width,
			height: Config.miniMap.height,
			collapsedWidth: 20,
			collapsedHeight: 20,
			toggleDisplay: true,
			position: 'bottomleft',
			strings: {
				hideText: 'Esconder minimapa',
				showText: 'Mostrar minimapa'
			}
		};

		new MiniMap(omsMini, miniMapOptions).addTo(this._mapa);
	}
}



// WEBPACK FOOTER //
// ./src/utils/leaflet-minimap.js